import React from "react";
import { Check, X } from "@phosphor-icons/react";

export default function VendorManagement({ pendingVendors, allVendors, onApprove, onSuspend }) {
  return (
    <div data-testid="admin-vendor-management">
      {pendingVendors.length > 0 && (
        <div className="mb-8">
          <h2 className="font-heading text-xl font-bold mb-3">Pending approval ({pendingVendors.length})</h2>
          <div className="space-y-2">
            {pendingVendors.map((v) => (
              <div key={v.vendor_id} className="card-surface p-4 flex items-center gap-4" data-testid="pending-vendor">
                <div className="w-12 h-12 rounded-xl overflow-hidden bg-[#F2EFE9] flex-shrink-0">
                  {v.cover_image_url && <img src={v.cover_image_url} alt={v.name} className="w-full h-full object-cover" />}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold truncate">{v.name}</p>
                  <p className="text-xs text-[#5C5C54] truncate">{v.description}</p>
                </div>
                <button
                  data-testid={`approve-${v.vendor_id}`}
                  onClick={() => onApprove(v.vendor_id)}
                  className="btn-primary text-xs gap-1"
                >
                  <Check size={14} weight="bold" /> Approve
                </button>fs
              </div>
            ))}
          </div>
        </div>
      )}
      <h2 className="font-heading text-xl font-bold mb-3">Approved ({allVendors.length})</h2>
      <div className="space-y-2">
        {allVendors.map((v) => (
          <div key={v.vendor_id} className="card-surface p-4 flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl overflow-hidden bg-[#F2EFE9] flex-shrink-0">
              {v.cover_image_url && <img src={v.cover_image_url} alt={v.name} className="w-full h-full object-cover" />}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-bold">{v.name}</p>
              <p className="text-xs text-[#5C5C54]">{v.total_orders} orders · {v.ratings_count} reviews</p>
            </div>
            <button onClick={() => onSuspend(v.vendor_id)} className="btn-secondary text-xs gap-1">
              <X size={14} weight="bold" /> Suspend
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
